module.exports = __webpack_public_path__ + "img/whiteList.e3cb7cff.png";